export const statuses = {
    unknown: {
        textColor: 'text-gray-500',
        label: 'Statut inconnu',
    },
    created: {
        textColor: 'text-gray-500',
        label: 'Étiquette créée',
    },
    pre_transit: {
        textColor: 'text-gray-500',
        label: 'Pré-transit',
    },
    in_transit: {
        textColor: 'text-orange-500',
        label: 'En transit',
    },
    out_for_delivery: {
        textColor: 'text-orange-500',
        label: 'En cours de livraison',
    },
    delivered: {
        textColor: 'text-green-500',
        label: 'Livré',
    },
    available_for_pickup: {
        textColor: 'text-orange-500',
        label: 'Disponible pour retrait',
    },
    return_to_sender: {
        textColor: 'text-red-500',
        label: "Retour à l'expéditeur",
    },
    failure: {
        textColor: 'text-red-500',
        label: 'Échec',
    },
    cancelled: {
        textColor: 'text-red-500',
        label: 'Annulé',
    },
    error: {
        textColor: 'text-red-500',
        label: 'Erreur',
    },
}

export const serviceCodes = {
    ExpressWorldwideNonDoc: {
        code: 'WPX',
        label: 'Expédition internationale',
    },
    DomesticExpress: {
        code: 'DOM',
        label: 'Expédition nationale',
    },
    ExpressWorldwideECX: {
        code: 'ECX',
        label: 'Expédition européenne',
    },
}

export const getVerboseShipment = (shipment) => {
    return {
        ...shipment,
        verbose_service: serviceCodes[shipment.service],
        verbose_tracking_status:
            statuses[shipment.tracking_status] || statuses.unknown,
    }
}
